import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    actionCardCta: 'Edit',
    actionCardDescription:
      'This virtual card will be automatically deactivated on {0}',
    addDateTitle: 'Add a deactivation date',
    cancel: 'Cancel',
    confirm: 'Confirm',
    description:
      'Do you need a virtual card for a defined period?\nThis card will be automatically deactivated when this date is reached.',
    editDateTitle: 'Deactivation date',
    title: 'Choose a deactivation date',
  },
  fr: {
    actionCardCta: 'Modifier',
    actionCardDescription:
      'Cette carte virtuelle sera automatiquement désactivée le {0}',
    addDateTitle: 'Ajouter une date de désactivation',
    cancel: 'Annuler',
    confirm: 'Valider',
    description:
      'Vous avez besoin d’une carte virtuelle pour une période définie\xA0?\nCette carte sera automatiquement désactivée une fois cette date atteinte.',
    editDateTitle: 'Date de désactivation',
    title: 'Choisir une date de désactivation',
  },
} as const);

export default locales;
